module.exports = __webpack_public_path__ + "static/media/camera-fotografica.69f20f63.svg";